import raw from "../../rawClients/rawCapiClient";
import routes from "../../capiRoutes";
import issueSerializer from "../../serializers/issues";
export default {
  getOneInProject(projectUid, issueUid) {
    return raw
      .get(routes.issues.oneInProject(projectUid, issueUid))
      .then(data => issueSerializer.fromServer(data));
  },
  updateOneInProject(projectUid, issueUid, issue) {
    return raw.patch(
      routes.issues.oneInProject(projectUid, issueUid),
      issueSerializer.toServer(issue)
    );
  },
};
